module.exports = {"driverJob":{"title":"Job List","navigate":"Navigate","start":"Start","end":"End","startCarMile":"ไมล์เริ่มต้น","endCarMile":"สิ้นสุดไมล์","fillDistanceStart":"กรอกแบบฟอร์มไมล์เริ่มต้น","fillDistanceEnd":"Fill in form mile end","pleaseCheckConfirm":"กรุณาตรวจสอบและยืนยันก่อนคืนรถ","checkMiles":"ตรวจสอบทั้งไมล์เริ่มต้นและสิ้นสุดของรถ","km":"Km","qDrive":"คิวของไดรฟ์","orderItem":"เรียงคิวตามวันที่และเวลา.","preparingDrive":"อยู่ในระหว่างการดำเนินการ","totalMile":"ไมล์สะสมทั้งหมด","totalCost":"ค่าใช้จ่ายทั้งหมด","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/driverJob.json
// module id = 755
// module chunks = 116